import { type RichTextDTO } from '../dto'

export const typography: RichTextDTO = {
  object: 'value',
  annotations: undefined,
  data: undefined,
  document: {
    data: undefined,
    nodes: [
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Bold',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          italic: false,
                          fontWeight: 700,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Underline',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          underline: true,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Regular',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Strike',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          strikethrough: true,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Uppercase',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          uppercase: true,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Ov',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          underline: true,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            text: 'e',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          italic: false,
                          underline: true,
                          fontWeight: 700,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            text: 'r',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          italic: false,
                          underline: false,
                          fontWeight: 700,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            text: 'lap',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [
                      {
                        value: {
                          italic: false,
                          underline: false,
                          fontWeight: 700,
                        },
                        deviceId: 'desktop',
                      },
                    ],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'Text Left',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'center',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: 'Text Center',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'center',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'center',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'right',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'right',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: 'Text Right ',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {
          textAlign: [
            {
              value: 'justify',
              deviceId: 'desktop',
            },
          ],
        },
        type: 'paragraph',
        nodes: [
          {
            text: 'Text Justify',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            data: {},
            type: 'code',
            nodes: [
              {
                text: 'code',
                marks: [
                  {
                    data: {
                      value: {
                        id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                        style: [],
                      },
                    },
                    type: 'typography',
                    object: 'mark',
                  },
                ],
                object: 'text',
              },
            ],
            object: 'inline',
          },
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            data: {
              type: 'OPEN_URL',
              payload: {
                url: 'https://makeswift.com',
                openInNewTab: false,
              },
            },
            type: 'link',
            nodes: [
              {
                text: 'link',
                marks: [
                  {
                    data: {
                      value: {
                        id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                        style: [],
                      },
                    },
                    type: 'typography',
                    object: 'mark',
                  },
                ],
                object: 'text',
              },
              {
                data: {},
                type: 'code',
                nodes: [
                  {
                    text: '',
                    marks: [
                      {
                        data: {
                          value: {
                            id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                            style: [],
                          },
                        },
                        type: 'typography',
                        object: 'mark',
                      },
                    ],
                    object: 'text',
                  },
                ],
                object: 'inline',
              },
              {
                text: '',
                marks: [
                  {
                    data: {
                      value: {
                        id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                        style: [],
                      },
                    },
                    type: 'typography',
                    object: 'mark',
                  },
                ],
                object: 'text',
              },
            ],
            object: 'inline',
          },
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            data: {},
            type: 'subscript',
            nodes: [
              {
                text: 'subscript',
                marks: [
                  {
                    data: {
                      value: {
                        id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                        style: [],
                      },
                    },
                    type: 'typography',
                    object: 'mark',
                  },
                ],
                object: 'text',
              },
            ],
            object: 'inline',
          },
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
          {
            data: {},
            type: 'superscript',
            nodes: [
              {
                text: 'superscript',
                marks: [
                  {
                    data: {
                      value: {
                        id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                        style: [],
                      },
                    },
                    type: 'typography',
                    object: 'mark',
                  },
                ],
                object: 'text',
              },
            ],
            object: 'inline',
          },
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: 'sadsf',
            marks: [
              {
                data: {
                  value: {
                    id: 'VHlwb2dyYXBoeTpiZjFhNzNlNi0yMGNkLTQwZjEtOThmMC02MDc5OWU2ZWJmZmE=',
                    style: [],
                  },
                },
                type: 'typography',
                object: 'mark',
              },
            ],
            object: 'text',
          },
        ],
        object: 'block',
      },
      {
        data: {},
        type: 'paragraph',
        nodes: [
          {
            text: '',
            marks: [],
            object: 'text',
          },
        ],
        object: 'block',
      },
    ],
    object: 'document',
  },
  selection: {
    focus: {
      path: [0, 0],
      object: 'point',
      offset: 0,
    },
    marks: undefined,
    anchor: {
      path: [0, 0],
      object: 'point',
      offset: 0,
    },
    object: 'selection',
    isFocused: false,
  },
}
